import type { FlatSurface } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { type PhotoDimensions, type Rect, surfaceMmToPhoto } from '@/entities/edit-area';
import { formatAreaMm } from '@/shared/lib';

interface MmSizeLabelProps {
  /** 표면 mm 사각형. 라벨은 위 변 가운데 바로 위에 놓는다. */
  readonly rect: Rect;
  readonly surface: FlatSurface;
  readonly photoSize: PhotoDimensions;
}

/** 끄는 중인 사각형의 실제 크기 라벨(`80 × 60 mm`). 포인터 이벤트는 받지 않는다. */
export const MmSizeLabel = ({ rect, surface, photoSize }: MmSizeLabelProps): ReactElement => {
  const topLeft = surfaceMmToPhoto(surface, photoSize, { xMm: rect.xMm, yMm: rect.yMm });
  const topRight = surfaceMmToPhoto(surface, photoSize, {
    xMm: rect.xMm + rect.widthMm,
    yMm: rect.yMm,
  });
  const fontSize = Math.max(photoSize.widthPx, photoSize.heightPx) * 0.014;
  return (
    <text
      x={(topLeft.x + topRight.x) / 2}
      y={topLeft.y - fontSize * 0.5}
      textAnchor="middle"
      fontSize={fontSize}
      fill="#1d4ed8"
      stroke="white"
      strokeWidth={fontSize * 0.2}
      paintOrder="stroke"
      pointerEvents="none"
    >
      {`${formatAreaMm(rect.widthMm)} × ${formatAreaMm(rect.heightMm)} mm`}
    </text>
  );
};
